import {
  CREATE_ACCOUNT_GROUP,
  FETCH_ACCOUNT_GROUP,
  FETCH_ACCOUNT_GROUPS,
  UPDATE_ACCOUNT_GROUP,
  RESET_CURRENT_GROUP
} from '../../constants/Constants';

export const fetchAccountGroups = () => ({ type: FETCH_ACCOUNT_GROUPS.REQUESTED });
export const fetchAccountGroup = groupId => ({ type: FETCH_ACCOUNT_GROUP.REQUESTED, payload: { groupId } });
export const createAccountGroup = payload => ({ type: CREATE_ACCOUNT_GROUP.REQUESTED, payload });
export const updateAccountGroup = payload => ({ type: UPDATE_ACCOUNT_GROUP.REQUESTED, payload });
export const resetCurrentGroup = payload => ({ type: RESET_CURRENT_GROUP });



// WEBPACK FOOTER //
// ./src/actions/entities/AccountGroupsActions.js